import { Button, Col, Form, Modal, Row } from "react-bootstrap";



const RecordIncome = () => {
  return (
    <div className="income-type-container">
      <div className="top-header-section" style={{ height: "55px" }}>
        <h1 className="page-title-text">Record Income</h1>
      </div>

      <div className="bg-white rounded pb-3">
         <Form>
        <Row className="g-3">

          {/* Bank Account */}
          <Col md={12}>
            <Form.Group>
              <Form.Label>
                Bank Account <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="bankAccount"
            
                required
              >
                <option value="">Select Bank Account</option>
                <option value="SBI">SBI</option>
                <option value="HDFC">HDFC</option>
                <option value="ICICI">ICICI</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Date */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>
                Date <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="date"
              
                required
              />
            </Form.Group>
          </Col>

          {/* Name Dropdown */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>
                Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="name"
              
                required
              >
                <option value="">Select Name</option>
                <option value="Client Payment">Client Payment</option>
                <option value="Project Income">Project Income</option>
                <option value="Other Income">Other Income</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Description */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                name="description"
             
                placeholder="Enter description"
              />
            </Form.Group>
            <small className="text-danger">Description cannot be blank.</small>
          </Col>

          {/* Amount */}
          <Col md={6}>
            <Form.Group>
              <Form.Label>
                Amount <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                name="amount"
          
                placeholder="Enter amount"
                required
              />

            </Form.Group>
             <small className="text-danger">Amount cannot be blank.</small>
          </Col>

        </Row>

        <div className="mt-3 d-flex justify-content-end mx-2">
          <Button type="submit" 
          style={{backgroundColor: "var(--color-primary)", border: "none" }}>
            Create
          </Button>
        </div>
      </Form>
      </div>
    </div>
  )
}

export default RecordIncome
